import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { restartableTask, timeout } from 'ember-concurrency';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("<div ...attributes>\n  {{#unless this.isAllVisible}}\n    <div class=\'grid-x grid-padding-x\'>\n      {{#if this.searchHasMany}}\n        <div class=\'cell medium-2\'>\n          <div role=\'button\' {{on \'click\' this.searchHasManyToggle}} class=\'link-button\'>\n            <FaIcon @icon=\'times\' role=\'presentation\' />\n          </div>\n        </div>\n        <div class=\'cell medium-10\'>\n          <input\n            id=\'primary-search\'\n            autocomplete=\'off\'\n            spellcheck=\'false\'\n            type=\'search\'\n            oninput={{perform this.debounceQTask value=\'target.value\'}}\n            placeholder=\'{{t \"search...\"}}\'\n            {{on-key firstResponder=true}}\n          />\n        </div>\n      {{else}}\n        <div class=\'cell medium-7\'>\n          <div role=\'button\' {{on \'click\' this.searchHasManyToggle}} class=\'link-button\'>\n            <FaIcon @icon=\'search\' role=\'presentation\' />\n          </div>\n          {{#if this.isPrevVisible}}\n            <div role=\'button\' {{on \'click\' (fn this.nextPrevHasMany false)}} class=\'link-button\'>\n              <FaIcon @icon=\'chevron-left\' role=\'presentation\' />\n            </div>\n          {{/if}}\n          {{#if this.isNextVisible}}\n            <div role=\'button\' {{on \'click\' (fn this.nextPrevHasMany true)}} class=\'link-button\'>\n              <FaIcon @icon=\'chevron-right\' role=\'presentation\' />\n            </div>\n          {{/if}}\n        </div>\n        <div class=\'cell medium-5\'>\n          {{#if this.loading}}\n            <BbSpinner />\n          {{else}}\n            <span class=\'beebeeLabel\'>\n              {{this.positionString}}\n            </span>\n          {{/if}}\n        </div>\n      {{/if}}\n    </div>\n  {{/unless}}\n</div>\n");

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
const DEBOUNCE_MS = 500;
let BbHasManyPaginatorComponent = (_class = class BbHasManyPaginatorComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "store", _descriptor, this);
    // Local mutable state (was Classic plain field mutated by set()/setProperties())
    _initializerDefineProperty(this, "pag", _descriptor2, this);
    _initializerDefineProperty(this, "xpag", _descriptor3, this);
    _initializerDefineProperty(this, "searchHasMany", _descriptor4, this);
    _initializerDefineProperty(this, "q", _descriptor5, this);
    _initializerDefineProperty(this, "loading", _descriptor6, this);
  }
  get filteredTotal() {
    return this.args.total ? this.args.total : 0;
  }
  get positionString() {
    const start = this.xpag * this.pag - this.xpag + 1;
    const end = Math.min(this.xpag * this.pag, this.filteredTotal);
    const total = this.filteredTotal;
    return `da ${start} a ${end} di ${total}`;
  }
  get isAllVisible() {
    return this.filteredTotal <= this.xpag ? true : false;
  }
  get isNextVisible() {
    return this.filteredTotal > this.pag * this.xpag;
  }
  get isPrevVisible() {
    return this.pag > 1;
  }
  *debounceQTask(value = null) {
    yield timeout(DEBOUNCE_MS);
    this.q = value;
    this.pag = 1;
    this.queryHasManyTask.perform();
  }
  *queryHasManyTask() {
    yield timeout(DEBOUNCE_MS);
    var query = {
      pag: this.pag,
      xpag: this.xpag,
      q: this.q,
      status: this.args.status?.id
    };
    query[this.args.item.constructor.modelName + '_id'] = this.args.item.get('id');
    this.loading = true;
    try {
      const relatedHasMany = yield this.args.relatedHasMany;
      let toDelete = relatedHasMany;
      if (this.args.status?.id) {
        toDelete = toDelete.filter(item => item.get('contact_state.id') === this.args.status.id);
      }
      const items = yield this.store.query(this.args.relatedModelType, query);
      if (this.args.status?.id) {
        toDelete.slice().forEach(i => {
          const _i = relatedHasMany.indexOf(i);
          if (_i !== -1) {
            relatedHasMany.splice(_i, 1);
          }
        });
        relatedHasMany.push(...items.slice());
      } else {
        // Remove all items, then re-add the queried page
        relatedHasMany.splice(0, relatedHasMany.length);
        relatedHasMany.push(...items.slice());
      }
    } finally {
      this.loading = false;
    }
  }
  nextPrevHasMany(next) {
    if (next) {
      this.pag = this.pag + 1;
    } else {
      this.pag = this.pag - 1;
      if (this.pag < 1) {
        this.pag = 1;
      }
    }
    this.queryHasManyTask.perform();
  }
  searchHasManyToggle() {
    this.searchHasMany = !this.searchHasMany;
    if (!this.searchHasMany) {
      this.q = null;
      this.pag = 1;
      this.queryHasManyTask.perform();
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "pag", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 1;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "xpag", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 10;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "searchHasMany", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "q", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "loading", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "debounceQTask", [restartableTask], Object.getOwnPropertyDescriptor(_class.prototype, "debounceQTask"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "queryHasManyTask", [restartableTask], Object.getOwnPropertyDescriptor(_class.prototype, "queryHasManyTask"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "nextPrevHasMany", [action], Object.getOwnPropertyDescriptor(_class.prototype, "nextPrevHasMany"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "searchHasManyToggle", [action], Object.getOwnPropertyDescriptor(_class.prototype, "searchHasManyToggle"), _class.prototype), _class);
setComponentTemplate(TEMPLATE, BbHasManyPaginatorComponent);

export { BbHasManyPaginatorComponent as default };
//# sourceMappingURL=bb-has-many-paginator.js.map
